import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTheme } from "@emotion/react";

// * Import custom components

// * Import kits
import Box from "../../kit/Box";
import Button from "../../kit/Button";

// * Import data & utils
import {
  northAmericanCountries,
  ASEANCountries,
  LATAMCountries,
  centralAndEasternEuropeCountriesList,
  affricanCountries,
  westernSuropeCountries,
} from "../../../assets/data/accountSetupData";
import location_img_light from "../../../assets/images/signup_images/light_theme/location_img.svg";
import location_img_dark from "../../../assets/images/signup_images/dark_theme/location_img_dark.svg";

// * Import styles
import { accountSetupStyles } from "../../theme/style";
import LocationContent from "./LocationContent";

import { getThemeName } from "../../utils/utils";

// # Component
const LocationScreen = ({
  setActiveScreen,
  templateData,
  activeStep,
  setActiveStep,
}) => {
  // # Hooks
  const locations = useSelector((state) => state.accountSetup.geography);
  const [countries, setCountries] = useState([]);
  const theme = useTheme();
  const classes = accountSetupStyles(theme);
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);
  const location_img = getThemeName(isDarkMode)
    ? location_img_dark
    : location_img_light;

  useEffect(() => {
    if (locations) {
      let allCountries = [];
      for (const location of locations) {
        if (location === "North America") {
          allCountries = [...allCountries, ...northAmericanCountries];
        }
        if (location === "APAC") {
          allCountries = [...allCountries, ...ASEANCountries];
        }
        if (location === "Western Europe") {
          allCountries = [...allCountries, ...westernSuropeCountries];
        }
        if (location === "Central and Eastern Europe") {
          allCountries = [
            ...allCountries,
            ...centralAndEasternEuropeCountriesList,
          ];
        }
        if (location === "LATAM") {
          allCountries = [...allCountries, ...LATAMCountries];
        }
        if (location === "Africa") {
          allCountries = [...allCountries, ...affricanCountries];
        }
      }
      setCountries(allCountries);
    }
  }, [locations]);

  const handleBack = () => {
    setActiveScreen((prev) => prev - 1);
  };

  const handleNext = () => {
    setActiveScreen((prev) => prev + 1);
    setActiveStep(activeStep + 1);
  };

  // # JSX
  return (
    <div
      className={classes.setupCardContainer}
      style={{ height: "100%", display: "flex", flexDirection: "row" }}
    >
      <Box className={classes.container}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "calc(100vh - 50px)%",
            overflow: "auto",
            paddingBottom: theme.size[50],
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: theme.sizeRem[3],
              position: "absolute",
              top: "200px",
            }}
          >
            <LocationContent templateData={templateData} />
          </div>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              background: theme.palette.tertiary.light,
              zIndex: "1000",
              padding: "20px 5px 0 22rem",
              position: "absolute",
              bottom: theme.size[30],
            }}
          >
            <Button
              disableRipple
              className={classes.accountSetupButtonOutlined}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              disableRipple
              className={classes.accountSetupButtonFilled}
              onClick={handleNext}
              disabled={countries.length ? false : true}
            >
              Next
            </Button>
          </Box>
        </div>
      </Box>
      <Box sx={{ height: "100%", width: "40%", position: "relative" }}>
        <img
          src={location_img}
          alt="error"
          style={{ height: "100%", position: "absolute", right: "-60px" }}
        />
      </Box>
    </div>
  );
};

// # Exports
export default LocationScreen;
